module.exports = __webpack_public_path__ + "img/unitedkingdom.1a0c27e6.svg";